module.exports = __webpack_public_path__ + "assets/normal/images/up.625b1606.png";